import { useCallback, useEffect, useState } from "react";
import { EVisibility } from "../../models/form";
import { Checkbox, Segment, Table } from "semantic-ui-react";
import { toast } from "../..";
import { getParameters, updateParameterVisibility } from "../../services/parametersService";
import { displayNetworkCodeOption, initParameterFilter, IParameter } from "../../models/parameter";
import { sortBySummaryThenByName } from "../../helpers/commonHelper";

export const ImplementationMapsSection = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [parameters, setParameters] = useState<IParameter[]>([]);

    const fetchPublishedParameters = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getParameters(initParameterFilter, 1, 1000, false, true);
            setParameters(sortBySummaryThenByName(res.result));
        } catch (err) {
            toast("Unable to fetch parameters", false, 3000);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPublishedParameters();
    }, [fetchPublishedParameters]);

    const handleUpdatePublicVisibilityForParameter = async (guid: string) => {
        try {
            setLoading(true);
            await updateParameterVisibility(guid);
            setParameters(
                parameters.map(parameter => {
                    if (parameter.guid === guid) {
                        return {
                            ...parameter,
                            visibility:
                                parameter.visibility === EVisibility.Public
                                    ? EVisibility.Internal
                                    : EVisibility.Public,
                        };
                    }
                    return parameter;
                })
            );
            toast("Country visibility set successfully", true, 1000);
        } catch (err) {
            toast("Unable to edit visibility", false, 3000);
        }
        setLoading(false);
    };

    return (
        <div className="section-container">
            <div className="title-container">
                <h2>Implementation maps:</h2>
            </div>

            <Segment>
                <Table basic="very" inline="centered" loading={loading}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Parameter</Table.HeaderCell>
                            <Table.HeaderCell>Network code</Table.HeaderCell>
                            <Table.HeaderCell>External publication</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {parameters.map(parameter => {
                            return (
                                <Table.Row key={parameter.guid}>
                                    <Table.Cell>{parameter.name}</Table.Cell>
                                    <Table.Cell>
                                        {displayNetworkCodeOption(parameter.networkCode)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Checkbox
                                            toggle
                                            checked={parameter.visibility === EVisibility.Public}
                                            onChange={() =>
                                                handleUpdatePublicVisibilityForParameter(
                                                    parameter.guid
                                                )
                                            }
                                            disabled={loading}
                                        />
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </Segment>
        </div>
    );
};
